<span
      class="char-counter"
      [class.char-counter--warn]="isNearLimit()"
      [class.char-counter--limit]="isAtLimit()">
      {{ currentLength() }}/{{ maxLength() }}
</span>